import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import { MailHistory } from "@/models/api/administration/mailBox/mailHistory";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { DataOptions } from "vuetify";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { FILTER_NAMES } from "@/static/filterNames";
import { getMailHistory, getMailHistoryContent } from "@/requests/mailBox";

export interface AdministrationMailBoxHistoryStateInterface {
  isTableLoading: boolean;
  tableOptions: DataOptions;
  tableData: Array<MailHistory>;
  tableFilters: Array<CriterionItemRequest> | null;
  tableCount: number;
  mailHistoryId: number | null;
}

export const AdministrationMailBoxHistoryState: AdministrationMailBoxHistoryStateInterface = {
  isTableLoading: false,
  tableOptions: new DefaultDataOptions(),
  tableData: new Array<MailHistory>(),
  tableFilters: null,
  tableCount: -1,
  mailHistoryId: null,
};

const AdministrationMailBoxHistoryModule = defineModule({
  state: AdministrationMailBoxHistoryState as AdministrationMailBoxHistoryStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsTableLoading(state, param: boolean) {
      state.isTableLoading = param;
    },
    setTableOptions(state, param: DataOptions) {
      state.tableOptions = param;
    },
    setTableData(state, param: Array<MailHistory>) {
      state.tableData = param;
    },
    setTableFilters(state, param: Array<CriterionItemRequest> | null) {
      state.tableFilters = param;
    },
    setTableCount(state, param: number) {
      state.tableCount = param;
    },
    setMailHistoryId(state, param: number | null) {
      state.mailHistoryId = param;
    },
  },
  actions: {
    async downloadMailHistory(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsTableLoading(true);
      const response = await getMailHistory({
        count: state.tableOptions.itemsPerPage,
        page: state.tableOptions.page - 1,
        criterions: state.tableFilters,
        filterName: FILTER_NAMES.MailHistoryFilter,
      });
      commit.setTableData(response.items);
      commit.setTableCount(response.totalCount);
      commit.setIsTableLoading(false);
    },
    async getMailHistoryContent(context, mailHistoryId: number) {
      return getMailHistoryContent(mailHistoryId);
    },
  },
});

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
export default AdministrationMailBoxHistoryModule;
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationMailBoxHistoryModule);
